<template>
  <div id="app">

    <div v-show="stage=='ENTERED'||$route.name=='AR'" class="app-header ">
      <div class="fixed left-0 top-0 px-4 py-3 text-4xl text-red-600 z-50 app-launch-ar select-none">
        <!-- GONOGO -->
        <!-- <div class="text-xl md:text-2xl text-red-600 border-2 border-red-600 uppercase px-2 py-1 mt-1 cursor-pointer pointer-events-auto hover:border-red-600  hover:text-red-600">
          Launch in AR
        </div> -->

        <!-- <router-link
        v-if="$route.name=='AR'"
        :to="{ name: 'Home' }"
        class="block text-base md:text-base text-black -border-2 -border-red-600 uppercase px-1 py-1 mt-0 cursor-pointer pointer-events-auto -hover:border-red-600 hover:text-red-600">
          Back to Project
        </router-link> -->

        <router-link
        v-if="$route.name!=='AR'"
        :to="{ name: 'AR' }"
        class="text-xl md:text-2xl text-red-600 border-2 border-red-600 uppercase px-2 py-1 mt-1 cursor-pointer pointer-events-auto hover:border-red-600  hover:text-red-600">
          Launch in AR
        </router-link>

      </div>

      <div
      v-if="$route.name!=='AR'"
      class="fixed right-0 top-0 m-4 h-8 rounded-full app-nav pointer-events-auto hidden md:block z-50 select-none" @mouseover="menuActive=true" @mouseleave="menuActive=false">
        <div class="w-8 h-8 relative z-50">
          <img src="/images/world2.svg" alt="" class="">
        </div>
        <div class="nav-wrapper hidden md:block" v-show="menuActive&&!mobileMenuActive">
          <router-link class="my-4 md:my-0 mx-3 text-white hover:text-red-600 uppercase" :to="{ name: 'About' }">About</router-link>
          <router-link class="my-4 md:my-0 mx-3 text-white hover:text-red-600 uppercase" :to="{ name: 'Contact' }">Contact</router-link>
        </div>
      </div>

      <div
      v-if="$route.name!=='AR'"
      class="fixed right-0 top-1 m-4 h-8 rounded-full app-nav pointer-events-auto block md:hidden z-50 select-none" @click="toggleMobileMenu">
        <div class="w-8 h-8 relative z-50">
          <img src="/images/world2.svg" alt="" class="">
        </div>
      </div>

      <div class="nav-wrapper nav-wrapper-mobile select-none"
      v-if="$route.name!=='AR'"
      v-show="mobileMenuActive">
        <router-link class="my-4 md:my-0 mx-3 text-white hover:text-red-600 uppercase" :to="{ name: 'About' }">About</router-link>
        <router-link class="my-4 md:my-0 mx-3 text-white hover:text-red-600 uppercase" :to="{ name: 'Contact' }">Contact</router-link>
        <div class="absolute bottom-0 inset-x-0">
          <a class="text-sm text-white text-opacity-40 text-center w-full block mx-auto p-2 " href="https://hato.co" target="_blank">Design and build by HATO</a>
        </div>
      </div>

    </div>

    <AppScene v-if="true" />
    <AppSceneControl v-if="stage=='ENTERED'"/>

    <Loading v-if="stage=='LOADING'"/>
    <Intro v-if="stage=='LOADED'"/>
    <Scroller v-if="stage=='ENTERED'"/>
    <Timeline v-if="stage=='ENTERED'"/>
    <Ending v-if="stage=='ENTERED'"/>

    <transition name="fade" mode="out-in">
      <router-view class="router-view"/>
    </transition>

  </div>
</template>

<script>
// @ is an alias to /src
import AppScene from '@/components/Scene/AppScene.vue'
import AppSceneControl from '@/components/Scene/AppSceneControl.vue'
import Loading from '@/components/Loading/index.vue'
import Intro from '@/components/Intro/index.vue'
import Timeline from '@/components/Timeline/index.vue'
import Ending from '@/components/Ending/index.vue'
import Scroller from '@/components/Scroller/index.vue'
import gsap from 'gsap'

export default {
  name: 'App',
  components: {
    AppScene,
    AppSceneControl,
    Loading,
    Intro,
    Timeline,
    Scroller,
    Ending
   },
  data () {
    return {
      menuActive: false,
      mobileMenuActive: false,
      arActive: false,
    }
  },
  watch: {
    '$route' (newVal, oldVal) {
      if (newVal.path != oldVal.path) {
        this.menuActive = false
        this.mobileMenuActive = false
        // this.onRouteChange(newVal)
      }
    }
  },
  computed: {
    stage () {
      return this.$store.state.stage
    }
  },
  methods: {

    onRouteChange (newVal) {
      if (newVal.path=='/') {
        // home
        // gsap.set('html, body, .scrollable', {
        //   pointerEvents: 'auto',
        //   border: '10px solid green'
        // })
        if (window) {
          // window.onscroll = function() {};
          window.document.body.style.overflow = "unset";
          window.document.body.style.pointerEvents = 'auto'
        }

      } else {

        if (window) {

          window.document.body.style.overflow = "hidden";
          window.document.body.style.pointerEvents = 'none'
          // Get the current page scroll position
          // let scrollTop = window.pageYOffset || window.document.documentElement.scrollTop;
          // let scrollLeft = window.pageXOffset || window.document.documentElement.scrollLeft;
          //
          // // if any scroll is attempted, set this to the previous value
          // window.onscroll = function() {
          //   window.scrollTo(scrollLeft, scrollTop);
          // };
        }

      }
    },

    clickAR () {
      this.stateUpdateStageAsEntered()
      this.$router.push({ name: 'AR', params: {} })
    },

    stateUpdateStageAsEntered() {
			this.$store.commit('setStage', { stage: 'ENTERED' })
		},

    toggleMenu () {
      console.log('toggleMenu')
      this.menuActive=!this.menuActive
    },

    toggleMobileMenu () {
      console.log('toggleMenu')
      this.mobileMenuActive=!this.mobileMenuActive
    },

    toggleAR () {
      this.arActive=!this.arActive
    },
    // reload () {
    //   // window.location.reload(true);
    //   this.$forceUpdate();
    //   window.location.href=`http://192.168.8.104:8080/index.html?${Date.now()}`
    // }
  }
}
</script>

<style lang="scss">
// @import '/fonts/fonts.css';
@import '/fonts/FK Display/fonts.css';

html, body {
  // position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  margin: 0;
  // height: 100%;
  margin: 0;
  background: hsl(0,10%,0%);
  font-family: 'FK Display Regular', Helvetica, Arial, sans-serif;
  -webkit-overflow-scrolling: touch;
}
*, *:before, *::after {
  box-sizing: border-box;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'FK Display Regular', Helvetica, Arial, sans-serif;
  // font-family: 'WhyteInktrap', sans-serif;
  font-weight: 400;
  font-style: normal;
  // background: red;

  // color: #00f;
  color: #fff;
  // font-weight: 400;

  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 100%;
  height: 100%;
}

.router-view {
  position: absolute;
  z-index:9;
  // top: 0;
  // left: 0;
  // height: 100%;

  // @apply absolute left-8 top-8 right-8 bottom-8;
  // border: 1px solid red;
  // width: 100%;
  // pointer-events: none;
}

#usdz-link {
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
}

.nav-wrapper {
  @apply fixed inset-0 bg-black z-30;
  @apply flex flex-col justify-center items-center text-center text-5xl gap-8;
  // z-index:999;

  @screen md {
    @apply absolute top-0 right-full flex pt-1 pr-3 text-base gap-0 bg-transparent;
    left: unset;
    bottom: unset;
    @apply block;
  }
}

canvas {
  &:focus,
  &:active {
    border: none;
    outline: none;
  }
}

.nav-links {
  @apply block text-center my-3 text-white text-opacity-60 hover:text-opacity-100;
  &.router-link-active {
    @apply text-opacity-100 text-red-600;
    // --tw-text-opacity: 100% !important;
  }
}


.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity .5s ease;
}

.fade-leave {}

.fade-leave-active {
  transition: opacity .5s ease;
  opacity: 0;
}

.view {
  pointer-events: auto;
  @apply absolute z-50 w-full h-auto bg-black text-white p-4;
  min-height: 100%;

  header {
    @screen lg {
      @apply fixed top-0 w-full p-4 left-0 right-0;
    }
    h1 {
      // @apply leading-none text-2xl absolute right-16 top-5;
      @apply leading-none text-2xl uppercase;
    }
  }
}

article {
  // @apply mx-auto block max-w-screen-sm ;
  @apply w-full px-1;

  h3 {
    &:not(:first-child) {
      @apply mt-24;
    }
    @apply text-3xl mb-8 text-red-600 mx-auto max-w-screen-lg block uppercase text-center font-normal;

    @screen lg {
      @apply text-7xl;
    }
  }
  p {
    &:not(:first-child) {
      @apply mt-4;
    }
    @apply text-base mb-4 leading-relaxed mx-auto block max-w-screen-sm;
  }
  a {
    @apply text-red-500;
    text-decoration: underline;
    -webkit-text-decoration-color: rgba(220, 38, 38, 1); /* Safari */
    text-decoration-color: rgba(220, 38, 38, 1);
  }
  .lg-col-3 {
    @screen lg {
      column-count: 3
    }
    div {
      // line-height: 1.5;
      @apply mb-8;
    }
  }
}
</style>
